import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  parentAttributeAddPath,
  ParentAttributeAddUrlQueryParams,
  parentAttributeListPath,
  ParentAttributeListUrlQueryParams,
  ParentAttributeListUrlSortField,
  parentAttributePath,
  ParentAttributeUrlQueryParams,
} from "./urls";
import ParentAttributeCreateComponent from "./views/ParentAttributeCreate";
import ParentAttributeDetailsComponent from "./views/ParentAttributeDetails";
import ParentAttributeListComponent from "./views/ParentAttributeList";

const ParentAttributeList = ({ location }: RouteComponentProps<{}>) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: ParentAttributeListUrlQueryParams = asSortParams(qs, ParentAttributeListUrlSortField);

  return <ParentAttributeListComponent params={params} />;
};

const ParentAttributeCreate = ({ location }: RouteComponentProps<{}>) => {
  const qs = parseQs(location.search.substr(1));
  const params: ParentAttributeAddUrlQueryParams = qs;

  return <ParentAttributeCreateComponent params={params} />;
};

const ParentAttributeDetails = ({ location, match }: RouteComponentProps<{ id: string }>) => {
  const qs = parseQs(location.search.substr(1));
  const params: ParentAttributeUrlQueryParams = qs;

  return (
    <ParentAttributeDetailsComponent
      id={decodeURIComponent(match.params.id)}
      params={params}
    />
  );
};

export const ParentAttributeSection = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.parentAttributes)} />
      <Switch>
        <Route exact path={parentAttributeListPath} component={ParentAttributeList} />
        <Route exact path={parentAttributeAddPath} component={ParentAttributeCreate} />
        <Route path={parentAttributePath(":id")} component={ParentAttributeDetails} />
      </Switch>
    </>
  );
};

export default ParentAttributeSection;